import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import i18n from "../../../i18next";

import PromotionSVG from '../../common/svgs/PromotionSVG';
import EmailWhiteSVG from '../../common/svgs/EmailWhiteSVG';
import SmsWhiteSVG from '../../common/svgs/SmsWhiteSVG';
import PercentWhiteSVG from '../../common/svgs/PercentWhiteSVG';

const ColoredIcon = props => {

    const { mainDiv } = styles;
    const additionalStyle = props.icon === 'sms' ? {paddingLeft: "5px"} : {};

    return (
        <div style={{...mainDiv, ...additionalStyle }} id={"icon" + props.icon}>
            {renderIcon(props.icon)}
            <UncontrolledTooltip placement="top" target={"icon" + props.icon} >
                {i18n.t('screens:customerInsightScreen.comingSoon')}
            </UncontrolledTooltip>
        </div>
    );

}

export default ColoredIcon;

const renderIcon = icon => {
    switch (icon) {
        case 'email': return <EmailWhiteSVG width={30} height={30} />
        case 'sms': return <SmsWhiteSVG width={30} height={30} />
        case 'percent': return <PercentWhiteSVG width={30} height={30} />
        default: return null;
    }
}

const styles = {
    mainDiv: {
        height: '40px',
        width: '40px',
        backgroundColor: 'rgb(236,18,116)',
        borderRadius: '5px',
        margin: '5px 7px 0 7px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/ColoredIcon.js